// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  DnaSyngoviaNodesType,
  DnaSyngoviaNodeType,
} from '../interfaces/dna-syngovia-node';

export type DnaSyngoviaSelectionType = {
  selected: boolean;
  value: DnaSyngoviaNodeType;
};

export class DnaSyngoviaSelectionModel {
  public readonly selection: DnaSyngoviaSelectionType[];

  public constructor(values: DnaSyngoviaNodesType) {
    this.selection = values.map((value) => ({ selected: false, value }));
  }

  public selectAll(): void {
    this.selection.forEach((element) => (element.selected = true));
  }

  public deselectAll(): void {
    this.selection.forEach((element) => (element.selected = false));
  }

  public selectedValues(): DnaSyngoviaNodeType[] {
    return this.selection
      .filter((element) => element.selected === true)
      .map((element) => element.value);
  }

  public isAllSelected(): boolean {
    const notSelectedNode = this.selection.find(
      (element) => element.selected === false
    );
    return notSelectedNode === undefined;
  }

  public isIndeterminate(): boolean {
    const selectedNodes = this.selection.filter(
      (element) => element.selected === true
    );

    return !this.isAllSelected() && selectedNodes?.length > 0;
  }

  public toggleAll(checked: boolean): void {
    if (checked) {
      this.selectAll();
    } else {
      this.deselectAll();
    }
  }

  public toggleSelection(element: DnaSyngoviaSelectionType): void {
    if (element) {
      element.selected = !element.selected;
    }
  }
}
